<!-- =========================================================================================
    File Name: Insight.vue
    Description: Price Optimization Recommendation
    ----------------------------------------------------------------------------------------
    Item Name: Appyvue - Bootstrap App with PY and VUE
    Author: @nand
========================================================================================== -->
<template>
  <div id="insight" class="mt-base">
    <div class="vx-row" v-if="false">
      <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
        <vx-card slot="no-body" class="text-center greet-user">
          <feather-icon
            icon="AlertTriangleIcon"
            class="p-6 mb-8 bg-warning inline-flex rounded-full text-white shadow"
            svgClasses="h-8 w-8"
          ></feather-icon>
          <h1 class="mb-6">2,844 Units</h1>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto mb-5">Total Inventory</p>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
        <vx-card slot="no-body" class="text-center greet-user">
          <feather-icon
            icon="AlertTriangleIcon"
            class="p-6 mb-8 bg-warning inline-flex rounded-full text-white shadow"
            svgClasses="h-8 w-8"
          ></feather-icon>
          <h1 class="mb-6">
            <sup class="text-lg">AED</sup> 2,968,680
          </h1>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto mb-5">Inventory Cost</p>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card title="Stock Segments">
          <!-- CHART -->
          <div>
            <!-- <vue-apex-charts type="donut" height="250" :options="analyticsData.donutChart.chartOptions" :series="analyticsData.donutChart.series"></vue-apex-charts> -->

            <vs-list>
              <vs-list-item
                title="740 Units ~ AED 836,776"
                subtitle="Fast Moving Goods ( FMG )"
              >Price Optimized</vs-list-item>

              <vs-list-item title="921 Units ~ AED 933,601" subtitle="Slow Moving Goods ( SMG )">
                <vs-button color="danger" @click="showFirstBundleSku">Bundle Offers</vs-button>
              </vs-list-item>

              <vs-list-item
                title="1183 Units ~ AED 1,198,302"
                subtitle="Medium Moving Goods ( MMG )"
              >Price Optimized</vs-list-item>
              <!-- <vs-list-item title="Obsolete Goods" subtitle="300 Units ~ $90000">
                <vs-button color="danger">Promote</vs-button>
              </vs-list-item>-->
            </vs-list>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <!-- <pre>{{unitSelectedBundle}}</pre> -->
      <div class="vx-col w-full mb-base" :class="showStatsPanel ? 'lg:w-2/3' : 'lg:w-full'" v-show="!showStatsPanel">
        <vx-card title="Skus with Bundle Recommendation">
          <vs-table
            pagination
            max-items="5"
            search
            :data="recommendData.stock"
            @selected="handleSelected"
          >
            <template slot="thead">
              <vs-th></vs-th>
              <vs-th sort-key="sku_id">Sku Id</vs-th>
              <vs-th sort-key="short_description">Sku Desc</vs-th>
              <vs-th sort-key="brand">Brand</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr
                :state="applyState('UNIT', tr)"
                :data="tr"
                :key="indextr"
                v-for="(tr, indextr) in data"
              >
                <vs-td>{{ data[indextr].row ? data[indextr].row : (indextr+1) }}</vs-td>

                <vs-td :data="data[indextr].sku_id">{{ data[indextr].sku_id }}</vs-td>

                <vs-td :data="data[indextr].short_description">{{ data[indextr].short_description }}</vs-td>

                <vs-td :data="data[indextr].brand">{{ data[indextr].brand }}</vs-td>

              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
      <div
        class="vx-col w-full mb-base"
        :class="showStatsPanel ? 'lg:w-2/3' : ''"
        v-show="showStatsPanel"
      >
        <vx-card title="Skus to Bundle">
          <vs-table
            pagination
            max-items="5"
            search
            :data="bundleStocks"
            @selected="handleSelectedBundle"
          >
            <template slot="thead">
              <vs-th></vs-th>
              <vs-th sort-key="sku_id">Sku Id</vs-th>
              <vs-th sort-key="short_description">Sku Desc</vs-th>
              <vs-th sort-key="brand">Brand</vs-th>
              <vs-th sort-key="product_category">Category</vs-th>
              <vs-th sort-key="rsv">RSV</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr
                :state="applyState('BUNDLE', tr)"
                :data="tr"
                :key="indextr"
                v-for="(tr, indextr) in data"
              >
                <vs-td>{{ data[indextr].row ? data[indextr].row : (indextr+1) }}</vs-td>

                <vs-td :data="data[indextr].sku_id">{{ data[indextr].sku_id }}</vs-td>

                <vs-td :data="data[indextr].short_description">{{ data[indextr].short_description }}</vs-td>

                <vs-td :data="data[indextr].brand">{{ data[indextr].brand }}</vs-td>

                <vs-td :data="data[indextr].product_category">{{ data[indextr].product_category }}</vs-td>

                <vs-td :data="data[indextr].rsv">{{ data[indextr].rsv }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
      <div
        class="vx-col w-full mb-base"
        :class="showStatsPanel ? 'lg:w-1/3' : ''"
        v-show="showStatsPanel"
      >
        <vx-card
          title="Sku Bundle details"
          title-color="#fff"
          class="bg-primary-gradient"
        >
          <template slot="actions">
            <feather-icon icon="XCircleIcon" svgClasses="w-6 h-6 text-white" @click="hideAlertContainer"></feather-icon>
          </template>
          <div slot="no-body" class="p-6">
            <div class="vx-col w-full mb-base">
              <vx-card
                :title="unitSelected && unitSelected.sku_id ? unitSelected.short_description : 'Sku desc here'"
                :subtitle="'Brand ~ ' + (unitSelected && unitSelected.brand ? unitSelected.brand : '-')"
              >
                <template slot="no-body">
                  <div class="p-8 clearfix">
                    <div>
                      <h1>
                        <strong>{{calculateBundlePrice | numFormat('$ 0,0') }}</strong>
                      </h1>
                      <small>
                        <span
                          class="text-grey"
                        >Item Price ~ {{(unitSelected && unitSelected.new_price ? unitSelected.new_price : '-') | numFormat('$ 0,0')}}</span>
                      </small>
                    </div>
                    <div class="flex justify-end">
                      <vs-button
                        type="filled"
                        color="primary"
                        gradient-color-secondary="rgb(130, 207, 23)"
                        icon-pack="feather"
                        icon="icon-search"
                        @click="bundleIt()"
                        v-bind="{disabled : isLoading}"
                        ref="bundleButton" 
                        id="bundleButton" 
                        class="vs-con-loading__container" 
                        vslor="primary"
                      >Bundle It</vs-button>
                    </div>
                  </div>
                </template>
              </vx-card>
            </div>
            <div class="vx-col w-full">
              <vx-card title="Bundled Items">
                <p></p>
                <div
                  v-for="(sku, index) in (unitSelectedBundle ? unitSelectedBundle : [])"
                  :key="sku.sku"
                  :class="{'mt-4': index}"
                >
                <!-- <div v-if="unitSelected.bundle && unitSelected.bundle.sku_id"> -->
                  <div class="flex justify-between">
                    <div class="flex flex-col">
                      <span class="mb-1">{{ sku.short_description }}</span>
                      <h1>
                        <strong>{{sku.rsv | numFormat('$ 0,0') }}</strong>
                      </h1>
                      <p>
                        <span class="text-grey">{{sku.product_category}}</span>
                      </p>
                    </div>
                  </div>
                  <vs-divider />
                </div>
              </vx-card>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/app/shared/components/statistics-cards/StatisticsCardLine.vue";
import analyticsData from "./analyticsData.js";

export default {
  props: {
    artefact: { type: Object, required: true }
  },
  data() {
    return {
      analyticsData: analyticsData,
      showStatsPanel: false,
      totalInventoryCost: 0,

      unitSelected: {},
      unitSelectedBundle: [],
      
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot"
      ],
      recommendData: {
        stat: {
          objective: "Maximize ROS",
          platformDiscount: 30,
          recommends: 0,
          promotions: 0
        },
        stock: []
      },
      bundleStocks: []
    };
  },
  watch: {},
  computed: {
    filteredStock() {
      return this.recommendData.stock.filter(
        item => item.is_bundle_flag === 1 && item.bundle.length > 0
      );
    },
    inventoryCost() {
      let invCost = 0;
      this.recommendData.stock.filter(
        item => (invCost += Number(item.old_price))
      );

      return invCost;
    },
    fastMoving() {
      return this.recommendData.stock.filter(item => item.sold_flag > 0);
    },
    slowMoving() {
      return this.recommendData.stock.filter(item => item.sold_flag === 0);
    },
    fastMovingCost() {
      let fmCost = 0;
      this.fastMoving.filter(item => (fmCost += Number(item.old_price)));

      return fmCost;
    },
    slowMovingCost() {
      let smCost = 0;
      this.slowMoving.filter(item => (smCost += Number(item.old_price)));

      return smCost;
    },
    mediumMoving() {
      return (
        this.recommendData.stock.length -
        (this.fastMoving.length + this.slowMoving.length)
      );
    },
    mediumMovingCost() {
      return this.inventoryCost - (this.fastMovingCost + this.slowMovingCost);
    },
    priceDecreasedStock() {
      return this.recommendData.stock.filter(
        item => Number(item.new_price) < Number(item.old_price)
      );
    },
    calculateBundlePrice() {
      let bCost = 0;
      if (this.unitSelectedBundle) {
        this.unitSelectedBundle.filter(item => (bCost += Number(item.rsv)));
      }

      return Number(this.unitSelected.new_price) + bCost;
    },
    chartData() {
      let chartData = {};
      this.priceTrend.series[0].data = [];
      Object.assign(chartData, this.priceTrend);
      if (this.unitSelected && this.unitSelected.trend) {
        for (let i = 0; i < this.unitSelected.trend.length; i++) {
          // chartData.series[0].data.push(Number(this.unitSelected.trend[i]));
        }
      }

      return chartData;
    }
  },
  methods: {
    buildRecommendData() {
      let selectedUnit =
        this.artefact.tags && this.artefact.tags.length > 1
          ? this.artefact.tags[1].tag
          : "";
      let selectedUnitData = this.artefact.res.recommend.data.filter(
        item =>
          item.product_category.toLowerCase() === selectedUnit.toLowerCase()
      );
      let discountStocks = selectedUnitData.filter(
        item => item.recommended_discount_percent > 0
      );
      let recommendedStocks = selectedUnitData.filter(
        item => item.bundle_flag === 1
      );
      let promotionStocks = selectedUnitData.filter(
        item => item.promotion_flag === 1
      );

      this.recommendData.stock = recommendedStocks;
      this.recommendData.stat.objective = "Maximize ROS";
      this.recommendData.stat.platformDiscount =
        discountStocks.length / selectedUnitData.length;
      this.recommendData.stat.recommends =
        recommendedStocks.length / selectedUnitData.length;
      this.recommendData.stat.promotions =
        promotionStocks.length / selectedUnitData.length;
    },
    showFirstBundleSku() {
      this.unitSelected = this.filteredStock[0];
      this.showStatsPanel = this.unitSelected && this.unitSelected.sku_id;
    },
    handleSelected(tr) {
      this.unitSelected = this.unitSelected.sku_id === tr.sku_id ? {} : tr;
      this.unitSelectedBundle = this.unitSelected.bundle ? this.unitSelected.bundle : [];

      this.bundleStocks = this.artefact.res.bundle.data.filter(
        item => 
          (this.unitSelected.bundle_1 ? (item.product_category.toLowerCase() === this.unitSelected.bundle_1.toLowerCase()) : false) ||
          (this.unitSelected.bundle_2 ? (item.product_category.toLowerCase() === this.unitSelected.bundle_2.toLowerCase()) : false) ||
          (this.unitSelected.bundle_3 ? (item.product_category.toLowerCase() === this.unitSelected.bundle_3.toLowerCase()) : false) ||
          (this.unitSelected.bundle_4 ? (item.product_category.toLowerCase() === this.unitSelected.bundle_4.toLowerCase()) : false) ||
          (this.unitSelected.bundle_5 ? (item.product_category.toLowerCase() === this.unitSelected.bundle_5.toLowerCase()) : false)
      );
      this.showStatsPanel = this.unitSelected && this.unitSelected.sku_id;
    },
    handleSelectedBundle(tr) {
      let bundleCount = this.unitSelectedBundle && this.unitSelectedBundle.length ?  this.unitSelectedBundle.length : 0;
      if(this.unitSelectedBundle && this.unitSelectedBundle.length > 0) {
        this.unitSelectedBundle =  this.unitSelectedBundle.filter(item => item.sku_id !== tr.sku_id);
        if(bundleCount === this.unitSelectedBundle.length) {
          this.unitSelectedBundle.push(tr);
        }
      } else {
        this.unitSelectedBundle.push(tr);
      }
    },    
    applyState(type, tr) {
      if(type === 'UNIT'){
        return tr.sku_id === this.unitSelected.sku_id ? "primary" : "";
      } else {
        return this.unitSelectedBundle.filter(item => item.sku_id === tr.sku_id).length > 0 ? "primary" : "";
      }
    },
    bundleIt() {
      this.unitSelected.bundle = this.unitSelectedBundle;
    },
    hideAlertContainer() {
      this.showStatsPanel = false;
    },
  },
  mounted() {
    this.buildRecommendData();
  },
  components: {
    VueApexCharts,
    StatisticsCardLine
  }
};
</script>

<style lang="scss">
#insight {
}
</style>
